module.exports = __webpack_public_path__ + "img/38.eec99e44.png";